import styled from 'styled-components';
import { Logo } from '@global/design-system/atoms';

export const ParentContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding-bottom: ${({ theme }) => theme.spacing?.xxl};
`;

export const TextContainer = styled.div`
	margin-top: ${({ theme }) => theme.spacing?.xl};
	gap: ${({ theme }) => theme.spacing?.large};
	text-align: center;
	display: flex;
	flex-direction: column;
	text-align: center;
`;

export const NicheLogo = styled(Logo)`
	width: 240px;
	height: auto;
`;
